<template>
  <div class="recommend-lp">
    <div class="media">
      <img src="/static/img/toppage/lp/head_mediaInfo.svg" alt="TV出演実績">
      <p>「占いメガネ」<span class="braced">TBS</span>
      <p>&nbsp;&nbsp;&nbsp;占いリアリティーSHOW<br>「どこまで言っていいですか？」<span class="braced">テレビ東京</span></p>
      <p>「占いなんて信じない」<span class="braced">テレビ東京</span></p>
    </div>
    <div class="banner-wrap">
      <!-- NEWRelease -->
      <p class="banner-subtitle">【PR】New Release</p>
      <a href="https://kurenotori.jp?utm_source=uranai.tv&utm_medium=referral&utm_campaign=LO00100001"><img class="banner-yearluck-2023 maru" src="/static/img/banner/kurenotori_2.jpg"></a>
    </div>
    <div class="banner-wrap">
      <!-- 年運バナー -->
      <a href="/2023_luck"><img class="banner-yearluck-2023" src="/static/img/banner/bnr_yearluck2023_large_20221226a.png"></a>
    </div>

    <div class="recommend">
      <ul>
        <li class="lp1"><a href="/recommend/lp/1"><img src="/static/img/toppage/lp/recommendLp_kurenotori.png" alt="暮れの酉"></a></li>
        <li class="lp4"><a href="/recommend/lp/4"><img src="/static/img/toppage/lp/recommendLp_hoen.png" alt="法演"></a></li>
        <li class="lp3"><a href="/recommend/lp/3"><img src="/static/img/toppage/lp/recommendLp_towa.png" alt="斗弥"></a></li>
        <li class="lp2"><a href="/recommend/lp/2"><img src="/static/img/toppage/lp/recommendLp_kanoucoco.png" alt="叶ここ"></a></li>
        <li class="lp5"><a href="/recommend/lp/5"><img src="/static/img/toppage/lp/recommendLp_ottimo.png" alt="オッティモちゃん"></a></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecommendLp',
}
</script>

<style scoped lang="scss">
@import "../../../../../sass/commons/commonVariables.scss";

.recommend-lp {
  margin: 0 0 10.667%;
  img {
    max-width: 100%;
    vertical-align: middle;
  }
  .media {
    margin: 0 0 30px;
    background: rgba(255, 245, 248, 0.8);
    padding: 20px 40px 20px;
    display: block;
    img {
      display: block;
      width: 100%;
      margin-bottom: 16px;
    }
    p {
      font-size: 14px;
      font-weight: bold;
      line-height: 22px;
      letter-spacing: -1px;
      text-align: left;
      color: #32373f;
      margin: 0 0 4px;
      .braced {
        &::before {
          content: "（";
          margin-left: -10px;
          letter-spacing: 0;
        }
        &::after {
          content: "）";
          margin-right: 3px;
          letter-spacing: 0;
        }
      }
    }
    @include mq('w580') {
      padding: 32px 64px 32px;
      p {
        font-size: 20px;
        line-height: 30px;
      }
    }
  }
  .recommend {
    padding: 0 5.333%;
    > ul {
      padding: 0;
      margin: 0 -2.4% -2.4% 0;
      display: flex;
      flex-wrap: wrap;
      > li {
        list-style: none;
        flex: 1 1 50%;
        max-width: 50%;
        padding: 0 2.6162% 2.32558% 0;
      }
    }
  }

  .banner-wrap {
    width: 100%;
    padding: 8px 5.333% 20px;
    a {
      display: block;
      img {
        display: block;
        width: 100%;
      }
    }
  }
  .maru{
    border-radius: 12px;
  }
  .banner-subtitle{
    text-align: center;
    margin-bottom: 4px;
    font-size: 20px;
    @include mq('w580') {
      font-size: 29px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Toppage/section/RecommendLp.vue